import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import {
  isInViewFooterState,
  stepState,
  inquiryState,
  inputState,
  selectedProductState,
} from '../../../states/messageState'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'
import { useCheckEmail } from '../../../hooks/useCheckEmail'

export const InputOverView: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()
  const { checkEmail } = useCheckEmail()

  const [input, setInput] = useRecoilState(inputState)

  const selectedProduct = useRecoilValue(selectedProductState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)
  const setInquiry = useSetRecoilState(inquiryState)

  /** 原因入力完了*/
  const handleSubmitOverView = async () => {
    setInquiry((prev) => ({ ...prev, description: input }))
    setIsInViewFooter(false)
    await handleAddSenderParent('user', input)

    //悪意のある申請を防ぐためにplanProtectionTypeがBaseの場合は自然故障か質問する
    if (selectedProduct.planProtectionType === 'Base') {
      await handleAddSenderParent('bot', '自然故障ですか？')
      handleInViewFooter()
      setCurrentStep('chooseNaturalFailure')
    } else {
      checkEmail()
    }
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder="概要"
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmitOverView()}
        onClick={handleSubmitOverView}
      />
    </FooterContent>
  )
}
